/* eslint-disable import/prefer-default-export */
import { getContext, call, put, select, takeEvery } from 'redux-saga/effects';
import { getLogger } from '../../logger/index';
import { startCall, startCustomerCall, failedCustomerCall } from './actions';
import communication from '../communication';
import { getLocale } from '../intl/selectors';
import chatSelectors from '../chat/selectors';
import { setCustomerChat } from '../communication/actions';

const logger = getLogger('communicationVideo :: customer');

export function* deactivateCustomerVideoCallSaga(customerVideoCallId) {
  try {
    return yield call(updateCustomerVideoCallSaga, customerVideoCallId, { isActive: false });
  } catch (e) {
    logger.error(e);
  }
}

export function* updateCustomerVideoCallSaga(customerVideoCallId, data) {
  const http = yield getContext('http');
  const url = `/api/video/customercalls/${customerVideoCallId}.json`;

  logger.debug('Request for updateCustomerVideoCall', url, data);
  const response = yield call(http.put, url, data);
  logger.debug('Response for updateCustomerVideoCall', response);

  return response.data;
}

function* startCustomerCallSaga({ payload: { type, from, to } }) {
  const http = yield getContext('http');
  const locale = yield select(getLocale);

  const { currentAgent, customerChat } = yield select(communication.selectors.getCustomerChat);

  const anonymous = yield select(communication.selectors.getAnonymous);
  const requestUrl = `/api/video/customercalls.json?&_locale=${locale}`;
  const requestConfig = {};
  const { reply, ...anonymousRequest } = anonymous;

  const response = yield call(http.post, requestUrl, { ...anonymousRequest, type, agent: currentAgent }, requestConfig);
  if (response.status < 200 || response.status > 299) {
    logger.error('Response with HTTP status', response.status, response);
    yield put(failedCustomerCall(response.data));
  } else {
    const { customerVideoCall } = response.data;
    logger.debug('Start call', { type, from, to, customerVideoCall, customerChat: customerChat });
    yield put(startCall({ type, from, to, customerVideoCall, customerChat: customerChat }));
    yield put(setCustomerChat(response.data));
    // yield put(updateCallId(customerVideoCall, to.id));
  }
}

export function* watchCustomerActions() {
  yield takeEvery(startCustomerCall, startCustomerCallSaga);
}
